var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconGooglePlay = function SvgIconGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.566 8.507 5.46 2.147l-.002-.002c-.264-.147-.47-.199-.623-.202l9.16 9.154 2.57-2.59ZM4.133 2.525a1.53 1.53 0 0 0-.033.327v17.772c0 .174.026.325.067.45l9.152-9.296-9.186-9.253ZM21.02 11.15l-.006-.003-3.59-2.133-2.758 2.771 2.698 2.853 3.66-1.992c.467-.27.593-.557.593-.746 0-.19-.127-.478-.598-.75ZM4.866 21.658l9.12-9.19 2.513 2.654-11.024 6.359c-.249.11-.45.163-.61.177Z",
    fill: "currentColor"
  })));
};

export default SvgIconGooglePlay;